// ══════════════════════════════════════════════════════════════
// COMPASS – User Reducer
// ══════════════════════════════════════════════════════════════
import { createReducer, on } from '@ngrx/store';
import { UserActions } from './user.actions';
import { initialUserState, UserState } from './user.state';

export const userReducer = createReducer<UserState>(
  initialUserState,

  // Initialize Auth
  on(UserActions.initializeAuthSuccess, (state, { user, isAuthenticated }): UserState => ({
    ...state,
    user,
    isAuthenticated,
    isInitialized: true,
    error: null,
  })),

  on(UserActions.initializeAuthFailure, (state, { error }): UserState => ({
    ...state,
    isInitialized: true,
    error,
  })),

  // Login (handled via redirect, no state changes needed here)
  on(UserActions.login, (state): UserState => ({
    ...state,
    error: null,
  })),

  // Logout
  on(UserActions.logout, (): UserState => ({
    ...initialUserState,
    isInitialized: true,
  })),

  on(UserActions.logoutSuccess, (): UserState => ({
    ...initialUserState,
    isInitialized: true,
  })),

  // Session Expired
  on(UserActions.sessionExpired, (): UserState => ({
    ...initialUserState,
    isInitialized: true,
  })),

  // Token Refresh
  on(UserActions.refreshTokenSuccess, (state, { user, tokenExpiresAt, refreshTokenExpiresAt }): UserState => ({
    ...state,
    user,
    isAuthenticated: true,
    tokenExpiresAt,
    refreshTokenExpiresAt,
    error: null,
  })),

  on(UserActions.refreshTokenFailure, (state, { error }): UserState => ({
    ...state,
    error,
  })),

  // Forgot Password
  on(UserActions.forgotPassword, (state): UserState => ({
    ...state,
    error: null,
  })),

  on(UserActions.forgotPasswordSuccess, (state): UserState => ({
    ...state,
    error: null,
  })),

  on(UserActions.forgotPasswordFailure, (state, { error }): UserState => ({
    ...state,
    error,
  })),

  // Reset Password
  on(UserActions.resetPassword, (state): UserState => ({
    ...state,
    error: null,
  })),

  on(UserActions.resetPasswordSuccess, (state): UserState => ({
    ...state,
    error: null,
  })),

  on(UserActions.resetPasswordFailure, (state, { error }): UserState => ({
    ...state,
    error,
  })),

  // Set Company Permissions (from API)
  on(UserActions.setCompanyPermissions, (state, { roles, permissions }): UserState => ({
    ...state,
    user: state.user ? { ...state.user, roles, permissions } : null,
  }))
);
